import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { APPLICATION_NOTES_REVIEW_UPDATE_URL } from "../ApiUrls";
import { METHOD } from "../Constants";
import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class UpdateApplicationNotesReview extends BaseApiRequest {
  method = METHOD.HTTP.PUT;

  body = {};

  url = APPLICATION_NOTES_REVIEW_UPDATE_URL;

  constructor(noteId, payLoad) {
    super();
    this.body = payLoad;
    const paramList = [noteId];
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
